import { Node } from 'tiptap'
import { chainCommands, exitCode } from 'tiptap-commands'

export default class HardBreak extends Node {

  get name() {
    return 'hard_break'
  }

  get schema() {
    return {
      inline: true,
      group: 'inline',
      selectable: false,
      parseDOM: [
        { tag: 'br' },
      ],
      toDOM: () => ['br'],
    }
  }

  commands({ type }) {
    return {
      pasteBr: attrs => (state, dispatch) => {
        const { selection } = state
        const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
        const transaction = state.tr.insert(position, type.create())
        dispatch(transaction)
      },
    }
  }

  keys({ type }) {
    const command = chainCommands(exitCode, (state, dispatch) => {
      return true
    })
    return {
      'Enter': command,
      'Mod-Enter': command,
      'Shift-Enter': command,
    }
  }

}
